import { View } from '@shared/components/View';
import { RelatedLookupField } from '@shared/data/entity/fields/RelatedLookupField';
import { LazyRelatedLookupOverflowMenu } from '@shared/scenes/entity/components/fields/RelatedCardLookupEditField/LazyRelatedLookupOverflowMenu';
import { getComponentLabel, isRelatedCardLookupComponent } from '@shared/scenes/workflows/utils';
import { API } from '@shared/types/api';
import { AddressCollectionViewField } from './AddressCollectionViewField';
import { CardCollectionViewFieldContainer } from './CardCollectionViewFieldContainer';
import { DateCollectionViewField } from './DateCollectionViewField';
import { EmailCollectionViewField } from './EmailCollectionViewField';
import { NumberCollectionViewField } from './NumberCollectionViewField';
import { TagCollectionViewField } from './TagCollectionViewField';
import { TextCollectionViewField } from './TextCollectionViewField';

interface Props {
  field: RelatedLookupField;
  component: API.AnyComponent;
  workflowTemplateId: string;
}

export function RelatedLookupCollectionViewField({ field, component, workflowTemplateId }: Props) {
  if (field.isEmpty) {
    return null;
  }

  const extraCount = field.count - 1;
  const showOverflow = extraCount > 0 && isRelatedCardLookupComponent(component);

  return (
    <CardCollectionViewFieldContainer fieldType={field.fieldType}>
      <LeafField field={field} />
      {showOverflow && (
        <View stopPropagation>
          <LazyRelatedLookupOverflowMenu
            extraCount={extraCount}
            component={component}
            relatedField={field.relatedField}
            workflowTemplateId={workflowTemplateId}
            title={`${getComponentLabel(component)} (${field.count})`}
          />
        </View>
      )}
    </CardCollectionViewFieldContainer>
  );
}

function LeafField({ field }: { field: RelatedLookupField }) {
  const leafField = field.firstLeafField;
  if (leafField === null) {
    return null;
  }

  switch (leafField.fieldType) {
    case 'AddressField':
      return <AddressCollectionViewField field={leafField} />;
    case 'DateField':
      return <DateCollectionViewField field={leafField} />;
    case 'EmailField':
      return <EmailCollectionViewField field={leafField} />;
    case 'NumberField':
      return <NumberCollectionViewField field={leafField} />;
    case 'TagField':
      return <TagCollectionViewField field={leafField} />;
    case 'TextField':
      return <TextCollectionViewField field={leafField} />;
    default:
      return null;
  }
}
